import React from 'react';

const sectionOneItemList=[
    {
        title: '志愿智能推荐',
        desc: '基于大数据分析一键智能推荐高考志愿，为您推荐适合的“专业+大学”。'
    },
    {
        title: '志愿自主筛选',
        desc: '通过培养层次、高校标签、办学性质等，进一步筛选适合的专业和学校。'
    },
    {
        title: '历年大数据',
        desc: '一键查询近4年各大学专业的录取最低分、位次号等高考录取大数据。'
    },
    {
        title: '天赋测评',
        desc: '通过专业天赋测评为您量身筛选适合您的大学专业，选专业不再迷茫。'
    },
    {
        title: '招生章程与招生计划',
        desc: '汇集各校招生计划、招生章程，资讯第一时间更新、查询便捷。'
    },
    {
        title: '三位一体报考助手',
        desc: '根据考生的学考等第，轻松筛选符合“三位一体”报考资格的高校和专业。'
    },
    {
        title: '强基报考助手',
        desc: '根据考生选考科目，推荐符合报考要求的学校、专业，助报强基计划。'
    },
    {
        title: '艺考生和高职生专属模块',
        desc: '艺考大数据、艺考智能推荐、单考单招大数据板块为艺考生和高职生提供升学数据支撑和报考工具。'
    }
];

const sectionTwoItemsList=[
    {
        itemsList:[{title: '选考科目', desc: '通过专业查询出所有在浙招生的高校及<br/>选科要求。'},{title: '专业选考', desc: '一键查询我的选科能上哪些大学，哪些<br/>专业。'}],
        imgName: 'hal_btm_2.png',
        imgPosition: 'left'
    },
    {
        itemsList:[{title: '直通大学', desc: '查询在浙招生大学的学校介绍、招生简章、招生计划、<br/>学校详情、选科要求、联系方式等信息，关注您心仪的<br/>大学。'},{title: '查询专业', desc: '汇聚最新本专科专业信息，帮助考生按学科门类、专业<br/>分类或专业名称，查询掌握各专业介绍、课程方向、学<br/>习内容、'},],
        imgName: 'hal_btm_3.png',
        imgPosition: 'right'
    },
    {
        itemsList:[{title: '天赋测评、选科测评', desc: '专业、选考科目如何选择？通过科学的测评<br/>方法，帮助考生发现自身潜在的才能、特长<br/>和兴趣领域，选出适合自己的选考科目、专<br/>业。适合自己的才是最好的！'}],
        imgName: 'hal_btm_4.png',
        imgPosition: 'left'
    },
    {
        itemsList:[{title: '排行榜', desc: '展示国内权威教育评价机构发布的各类最新大学、专<br/>业、学科排行榜，作为考生选择院校、选择专业的重要<br/>参考和决策依据。'},{title: '生涯云', desc: '通过教授讲专业、专业解读、职业时空、大学开讲、生<br/>涯先锋营、高考新观察等栏目，帮助考生更全面了解生<br/>涯规划与升学规划。'},],
        imgName: 'hal_btm_5.png',
        imgPosition: 'right'
    }
]

const HalSectionOneItem=(props)=>{
    const { title, desc } = props.content;
    return(
        <div className="section1-item">
            <div>{title}</div>
            <div className="fs-14 fc-1" style={{lineHeight: "24px"}} dangerouslySetInnerHTML={{__html: desc}}></div>
        </div>
    )
}

const HalSectionItems=(props)=>{
    const { title, desc } = props.content;
    return(
        <div className="section2-item" style={props.itemLength === 1 ? {marginTop: 165}:{marginTop: 100}}>
            <div className="fs-28">{title}</div>
            <div className="fs-14 fc-1" style={{marginTop: 10, lineHeight: "24px"}} dangerouslySetInnerHTML={{__html: desc}}></div>
        </div>
    )
}

const HalSection=(props)=>{
    const { itemsList, imgName, imgPosition } = props.item;
    return(
        <div className="hal-item-wrapper2">
            <div className={imgPosition === "left" ? "fl-ri":"fl-lf"}>
                {itemsList.map((item,index)=>(<HalSectionItems key={index} content={item} imgPosition={imgPosition} itemLength={itemsList.length}/>))}
            </div>
            <img className={imgPosition === "left" ? "fl-lf":"fl-ri"} src={require(`../../../assets/images/${imgName}`)}/>
        </div>
    )
}

export const HalModule = (props) => {
    return(
        <div className="four-hal">
            <div className="four-right-top">
                <img src={require('../../../assets/images/hal-top.png')}/>
            </div>
            <div className="four-right-bottom-hal shadow">
                <div className="hal-item-wrapper1 relative">
                    <div className="section1-title fs-28">高考顾问</div>
                    {sectionOneItemList.map((item,index)=>(<HalSectionOneItem key={index} content={item}/>))}
                    <img src={require('../../../assets/images/hal_btm_1.png')}/>
                </div>
                {sectionTwoItemsList.map((item,index)=>(<HalSection key={index} item={item}/>))}
            </div>
        </div>
    )
}

export default HalModule;